import { render } from "./SS23Hero.vue?vue&type=template&id=1a6c58e6&scoped=true"
import script from "./SS23Hero.vue?vue&type=script&lang=js"
export * from "./SS23Hero.vue?vue&type=script&lang=js"

import "./SS23Hero.vue?vue&type=style&index=0&id=1a6c58e6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6c58e6"]])

export default __exports__